import { CheckboxTypes, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React, { useEffect } from 'react';
import { FlatList, StyleSheet, View } from 'react-native';

import { SecondCopyListEmpty } from '../SecondCopyListEmpty';
import { SecondCopyListHeader } from '../SecondCopyListHeader';
import { SecondCopyListItem } from '../SecondCopyListItem';
import { SecondCopyListLoading } from '../SecondCopyListLoading';

const styles = StyleSheet.create({
  container: {
    marginLeft: -Utils.Token.ToInt(Spacing, 'inset.xs'),
    marginRight: -Utils.Token.ToInt(Spacing, 'inset.xs'),
  },
  containerDesktop: {
    paddingBottom: Utils.Token.ToInt(Spacing, 'inset.xs'),
  },
  containerMobile: {
    flex: 1,
  },
  separator: {
    height: Utils.Token.ToInt(Spacing, 'inset.xs'),
  },
});

const Separator = () => <View style={styles.separator} />;

export interface SecondCopyListProps {
  linesChecked: CheckboxTypes.Option['value'][];
  setLinesChecked: React.Dispatch<React.SetStateAction<CheckboxTypes.Option['value'][]>>;
}

export const SecondCopyList: React.FC<SecondCopyListProps> = ({
  linesChecked,
  setLinesChecked,
}) => {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState<number[]>([]);
  const isMobile = useBreakpointValue({ base: true, sm: false });

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
      setData([1, 2, 3, 4, 5, 6]);
    }, 2000);
  }, []);

  const handleCheckItem = (id: string, selected: boolean) => {
    setLinesChecked((prev) => {
      if (!selected) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  const handleSelectAll = () => {
    if (linesChecked.length === data.length) {
      setLinesChecked([]);
    } else {
      setLinesChecked(data.map((item) => item.toString()));
    }
  };

  const isItemSelected = (id: string) => linesChecked.includes(id);
  const isAllItemsSelected = linesChecked.length === data.length;

  return (
    <VStack flex={1}>
      <SecondCopyListHeader handleCheckAll={handleSelectAll} selected={isAllItemsSelected} />
      <FlatList
        data={data}
        style={[styles.container, isMobile ? styles.containerMobile : styles.containerDesktop]}
        ItemSeparatorComponent={Separator}
        renderItem={({ item }) => (
          <SecondCopyListItem
            id={item.toString()}
            item={item}
            onCheck={handleCheckItem}
            selected={isItemSelected(item.toString())}
          />
        )}
        ListEmptyComponent={loading ? <SecondCopyListLoading /> : <SecondCopyListEmpty />}
        ListFooterComponent={loading && data.length ? <SecondCopyListLoading /> : null}
      />
    </VStack>
  );
};
